import React, { Component } from 'react'
import logo from '../images/logo.jpeg'
import 'bootstrap/dist/css/bootstrap.min.css'

export default class HeaderForSingle extends Component {

    state = {
        productCategory: ''
    }

    componentDidMount() {
        let productCategory = window.location.href
        productCategory = productCategory.substr(productCategory.lastIndexOf('/') + 1)
        productCategory = productCategory.split('-').join(' ')
        this.setState({ productCategory: productCategory })
    }

    handleLogo = () => {
        window.location.href = '/'
    }

    render() {
        return (
            <React.Fragment>
                <header>
                    <nav className="d-flex align-items-center top-padding">
                        {/* <div className="back-button">
                            <i className="fa fa-arrow-left" aria-hidden="true"></i>
                        </div> */}
                        <div onClick={this.handleLogo} className="logo-div ml-3">
                            <img src={logo} width="150px" />
                        </div>
                        <div className="commn-title-div ml-3">
                            {/* <h1>Watch On Time</h1> */}
                        </div>
                        {/* <div className="search-box-header ml-auto d-flex align-items-center">
                            <input type="search" className="form-control respo-input" />
                            <button className="btn btn-search-icn">
                                <i className="fa fa-search"></i>
                            </button>
                        </div> */}
                    </nav>
                    <div className="top-title">
                        <div className="commn-title-div">
                            <h2>{this.state.productCategory}</h2>
                            <p>{this.props.totalItem} items</p>
                        </div>
                    </div>
                    <div className="details-list">
                        <ul className="un-listed whitespace-nowrap">
                            <li><i className="fa fa-check mr-3"></i>Cash on delivery available.*</li>
                            <li><i className="fa fa-check mr-3"></i>Best in class quality with affordable rates. </li>
                            <li><i className="fa fa-check mr-3"></i>For more info send inquiry on whatsapp or visit our insta page.</li>
                            <li><i className="fa fa-check mr-3"></i> Dispatch within 1 to 3 days and delivery within 2 to 6 days after dispatch.*</li>
                            <li><i className="fa fa-check mr-3"></i> Free shipping all over India.*</li>
                        </ul>
                    </div>
                </header>
            </React.Fragment>
        )
    }
}
